import { CodeBlock } from "@tiptap/extension-code-block";
import {
  NodeViewContent,
  NodeViewProps,
  NodeViewWrapper,
  ReactNodeViewRenderer,
} from "@tiptap/react";
import mermaid from "mermaid";
import { useEffect, useId, useState } from "react";

const MermaidCodeBlock = ({ node }: NodeViewProps) => {
  const id = useId().replace(/:/g, "");
  const source = node.textContent;
  const isMermaid = node.attrs.language === "mermaid";
  const [svg, setSvg] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    setSvg("");
    setError(false);

    if (!isMermaid || !source.trim()) {
      return;
    }

    mermaid.initialize({ startOnLoad: false, securityLevel: "strict" });
    void mermaid
      .render(id, source)
      .then((result) => {
        if (active) {
          setSvg(result.svg);
        }
      })
      .catch(() => {
        if (active) {
          setError(true);
        }
      });

    return () => {
      active = false;
    };
  }, [id, isMermaid, source]);

  if (!isMermaid) {
    return (
      <NodeViewWrapper as="pre">
        <NodeViewContent as="code" />
      </NodeViewWrapper>
    );
  }

  return (
    <NodeViewWrapper className="mermaid-code-block">
      {svg && (
        <div
          className="mermaid-code-block-preview overflow-x-auto"
          contentEditable={false}
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      )}
      {error && (
        <div className="text-destructive text-sm" contentEditable={false}>
          Unable to render Mermaid diagram.
        </div>
      )}
      <pre>
        <NodeViewContent as="code" />
      </pre>
    </NodeViewWrapper>
  );
};

export const MermaidCodeBlockNodeWithView = CodeBlock.extend({
  addNodeView() {
    return ReactNodeViewRenderer(MermaidCodeBlock);
  },
});
